import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  titleTypo: {
    fontSize: 30,
    fontWeight: 800,
    marginRight: 10,
  },
  container: {
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 20,
    flexGrow: 1,
  },
}));
